import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Modal,
    Transfer,
    message,
    Divider,
    Rate,
    Popover,
    Typography, Popconfirm
} from 'antd';
import {Redirect, Link, withRouter} from 'react-router-dom';
import store from "../store/store.js";
import {CloseOutlined} from '@ant-design/icons'
import {
    StarOutlined,
    PlusCircleOutlined,
    FormOutlined,
    MobileOutlined,
    PhoneOutlined,
    WechatOutlined,
    MailOutlined,
    HomeOutlined,
    GlobalOutlined,
    FolderOpenOutlined,
    UserOutlined,
    HistoryOutlined,
    SearchOutlined,
    CopyOutlined
} from '@ant-design/icons'
import moment from 'moment';
import jfd from '../images/jfd.png'
import html2pdf from "html2pdf.js";

const {Paragraph} = Typography;
const {Search} = Input;
const {Option} = Select;
const {RangePicker} = DatePicker;

class Cuijiao extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            condition: {},
            loading: false,
            visible: false,
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentDidMount() {


    }

    mdchange() {
        let that = this
        let visible = !that.state.visible
        that.setState({
            visible
        })
        if (visible) {
            that.getdata()
        } else {
            that.setState({
                condition: {},
                loading: false
            })
        }
    }

    getdata() {
        let that = this
        let arr = {}
        arr.company_id = that.props.company_id
        fetch('/Pay/word', {
            method: "POST",
            body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                that.setState({
                    data: data.data,
                    msg: data.msg,
                    company_name: data.company_name
                })
            })
    }

    sendMessage() {
        let that = this
        let arr = {}
        arr.company_id = that.props.company_id
        fetch('Pay/sendMessage', {
            method: "POST",
            body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 1) {
                    message.success(data.msg)
                } else {
                    message.error(data.msg)
                }
            })
    }

    handleExportPdf = () => {
        this.setState({
            loading: true
        })
        var element = document.getElementById('downloadPDF');
        html2pdf(element, {
            margin: [15.5, 0, 15.5, 0],
            filename: (this.state.company_name ? this.state.company_name : '') + '催缴通知.pdf'
        }).then(() => {
            console.log('PDF generated successfully!');
            this.setState({
                loading: false
            })
        });
    }

    render() {
        return (
            <>
                <a href='javascript:void(0)' onClick={this.mdchange.bind(this)}>催缴</a>
                <Modal title="催缴" destroyOnClose={true} bodyStyle={{padding: 20}} width={800}
                       visible={this.state.visible} onCancel={this.mdchange.bind(this)} footer={null}>
                    <div className={'view_box'}>
                        {this.state.msg ? <>
                            <div style={{width: '100%', fontSize: 14, color: '#333', fontWeight: 'bold'}}>催缴短信</div>
                            <div className={'duanxin_content'}>
                                <div style={{width: '100%'}} dangerouslySetInnerHTML={{__html: this.state.msg}}></div>
                                <Row justify={"space-between"} style={{width: '100%'}}>
                                    <div></div>
                                    <Popconfirm
                                        title="确认发送短信?"
                                        onConfirm={() => this.sendMessage()}
                                        okText="确认"
                                        cancelText="取消"
                                    >
                                        <Button type={"primary"}>发送短信</Button>
                                    </Popconfirm>
                                    <Paragraph
                                        style={{marginBottom: 0}}
                                        copyable={{
                                            // format:'text/html',
                                            tooltips: false,
                                            icon: <Space><CopyOutlined/> 复制</Space>,
                                            text: this.state.msg,
                                        }}></Paragraph>
                                </Row>

                            </div>
                        </> : null}
                        {this.state.data ? <>
                            <div id={'downloadPDF'}
                                 dangerouslySetInnerHTML={{__html: this.state.data}}></div>
                            <Row justify={"center"} style={{width: '100%'}}>
                                <Button type={"primary"} loading={this.state.loading}
                                        onClick={() => this.handleExportPdf()}>下载通知单</Button>
                            </Row>
                        </> : null}
                    </div>
                </Modal>
            </>
        )
    }
}

export default Cuijiao
